document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-resort-id][data-section-id]');

  sections.forEach(async (section) => {
    const resortId = section.dataset.resortId;
    const sectionId = section.dataset.sectionId;
    const target = document.getElementById(`FnuggResort-${sectionId}`);

    const iconMap = {
      1: section.dataset.icon1,
      2: section.dataset.icon2,
      3: section.dataset.icon3,
      4: section.dataset.icon4,
      5: section.dataset.icon5,
      6: section.dataset.icon6,
      7: section.dataset.icon7,
      8: section.dataset.icon8,
      9: section.dataset.icon9
    };

    if (!resortId || !target) return;

    const sourceFields = [
      'id',
      'name',
      'site_path',
      'resort_open',
      'resort_opening_date',
      'resort_closing_date',
      'lifts.open',
      'lifts.count',
      'slopes.open',
      'slopes.count',
      'conditions.combined.top.temperature.value',
      'conditions.combined.top.snow.depth_terrain',
      'conditions.combined.top.snow.depth_slope',
      'conditions.combined.top.symbol.fnugg_id',
      'conditions.combined.top.wind.mps',
      'conditions.combined.top.wind.speed',
      'conditions.combined.top.wind.name',
      'conditions.combined.top.condition_description',
      'conditions.combined.bottom.temperature.value',
      'conditions.combined.bottom.snow.depth_terrain',
      'conditions.combined.bottom.snow.depth_slope',
      'conditions.combined.bottom.symbol.fnugg_id',
      'conditions.combined.bottom.wind.mps',
      'conditions.combined.bottom.wind.speed',
      'conditions.combined.bottom.wind.name',
      'conditions.combined.bottom.condition_description',
      'last_updated'
    ].join(',');

    const endpoint = `https://api.fnugg.no/get/resort/${encodeURIComponent(resortId)}?sourceFields=${encodeURIComponent(sourceFields)}`;

    try {
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
      const data = await response.json();

      if (!response.ok || data.error || !data._source) {
        throw new Error(data.error || `HTTP ${response.status}`);
      }

      const s = data._source;
      const top = s.conditions?.combined?.top || {};
      const bottom = s.conditions?.combined?.bottom || {};
      const isOpen = !!s.resort_open;
      const seasonStr = formatSeason(s.resort_opening_date, s.resort_closing_date);

      const stats = [
        statTile(s.lifts?.open, s.lifts?.count, 'Heiser åpne'),
        statTile(s.slopes?.open, s.slopes?.count, 'Bakker åpne'),
        statTileSimple(top.snow?.depth_slope, 'Snø i bakken', 'cm'),
        statTileSimple(avg(top.snow?.depth_terrain, bottom.snow?.depth_terrain), 'Snø i terrenget', 'cm')
      ].filter(Boolean).join('');

      const metaParts = [
        seasonStr ? `Sesong: ${seasonStr}` : '',
        `Oppdatert ${formatDate(s.last_updated)}`
      ].filter(Boolean).join(' · ');

      target.innerHTML = `
        <header class="fr-head">
          <div class="fr-titlewrap">
            <h3 class="fr-name">${escapeHtml(s.name || 'Skianlegg')}</h3>
            <p class="fr-meta">${escapeHtml(metaParts)}</p>
          </div>
          <span class="fr-status ${isOpen ? 'fr-status--open' : 'fr-status--closed'}">
            ${isOpen ? 'Åpent' : 'Stengt'}
          </span>
        </header>

        ${stats ? `<div class="fr-stats">${stats}</div>` : ''}

        <div class="fr-zones">
          ${renderZone('Topp', top, iconMap)}
          ${renderZone('Bunn', bottom, iconMap)}
        </div>

        <footer class="fr-credit">
          <span>Data: fnugg.no · Yr · Meteorologisk institutt · NRK</span>
        </footer>
      `;
    } catch (error) {
      console.error('Fnugg error:', error);
      target.innerHTML = `
        <div class="fr-error">
          <h3 class="fr-error-title">Kunne ikke hente vær- og føreinformasjon</h3>
          <p class="fr-error-text">Prøv igjen om litt, eller sjekk at resort-ID er riktig.</p>
        </div>
      `;
    }
  });

  function statTile(open, total, label) {
    if (open == null && total == null) return '';
    const o = (typeof open === 'number') ? open : '–';
    const t = (typeof total === 'number') ? `/${total}` : '';
    return `
      <div class="fr-stat">
        <div class="fr-stat-val">${escapeHtml(String(o))}<span class="fr-stat-sub">${escapeHtml(t)}</span></div>
        <div class="fr-stat-label">${escapeHtml(label)}</div>
      </div>
    `;
  }

  function statTileSimple(value, label, suffix = '') {
    if (value == null || value === '' || Number.isNaN(value)) return '';
    return `
      <div class="fr-stat">
        <div class="fr-stat-val">${escapeHtml(String(value))}<span class="fr-stat-sub">${escapeHtml(suffix)}</span></div>
        <div class="fr-stat-label">${escapeHtml(label)}</div>
      </div>
    `;
  }

  function renderZone(label, zone, iconMap) {
    if (!zone || Object.keys(zone).length === 0) return '';

    const iconId = zone.symbol?.fnugg_id;
    const iconUrl = getIconUrl(iconId, iconMap);
    const weatherText = getWeatherText(iconId);
    const temp = zone.temperature?.value;
    const condition = zone.condition_description;

    const windStr = formatWind(zone.wind);

    const meta = [
      weatherText !== 'Ukjent vær' ? weatherText : '',
      windStr,
      condition && condition !== 'Faste og fine forhold' ? condition : ''
    ].filter(Boolean).join(' · ');

    return `
      <div class="fr-zone">
        ${iconUrl ? `<div class="fr-zone-icon"><img src="${iconUrl}" alt="${escapeHtml(weatherText)}" loading="lazy"></div>` : ''}
        <div class="fr-zone-text">
          <div class="fr-zone-label">${escapeHtml(label)}</div>
          <div class="fr-zone-temp">${temp != null ? `${escapeHtml(String(temp))}°` : '–'}</div>
          ${meta ? `<div class="fr-zone-weather">${escapeHtml(meta)}</div>` : ''}
        </div>
      </div>
    `;
  }

  function formatWind(wind) {
    if (!wind || typeof wind !== 'object') return '';
    const mps = wind.mps;
    const speedText = wind.speed;
    const direction = wind.name;
    if (mps == null && !speedText) return '';

    const parts = [];
    if (mps != null) parts.push(`${mps} m/s`);
    if (direction) parts.push(direction);
    if (speedText && parts.length === 0) parts.push(speedText);
    return `Vind ${parts.join(' ')}`;
  }

  function avg(a, b) {
    const aNum = typeof a === 'number' ? a : null;
    const bNum = typeof b === 'number' ? b : null;
    if (aNum == null && bNum == null) return null;
    if (aNum == null) return bNum;
    if (bNum == null) return aNum;
    return Math.round((aNum + bNum) / 2);
  }

  function formatSeason(opening, closing) {
    const o = parseDate(opening);
    const c = parseDate(closing);
    if (!o && !c) return '';
    if (o && c) return `${formatDateShort(o)} – ${formatDateShort(c)}`;
    if (o) return `Åpner ${formatDateShort(o)}`;
    return `Stenger ${formatDateShort(c)}`;
  }

  function parseDate(value) {
    if (!value) return null;
    try {
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    } catch { return null; }
  }

  function formatDateShort(d) {
    return d.toLocaleDateString('nb-NO', { day: 'numeric', month: 'short' });
  }

  function getIconUrl(id, iconMap) {
    return iconMap?.[id] || '';
  }

  function getWeatherText(id) {
    const map = {
      1: 'Strålende sol',
      2: 'For det meste sol',
      3: 'Overskyet',
      4: 'Meldt snø',
      5: 'Det snør',
      6: 'Fare for regn',
      7: 'Det regner',
      8: 'Fare for sludd',
      9: 'Det sludder'
    };
    return map[id] || 'Ukjent vær';
  }

  function formatDate(value) {
    if (!value) return 'ukjent tidspunkt';
    try {
      const d = new Date(value);
      const day = d.toLocaleDateString('nb-NO', { day: 'numeric', month: 'long' });
      const time = d.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' });
      return `${day} kl. ${time}`;
    } catch {
      return escapeHtml(String(value));
    }
  }

  function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
});
